<template>
  <div class="blacklistResult text-left" v-title data-title="黑名单">
    <van-search
      v-model="params.keywords"
      shape="round"
      show-action
      :clearable="false"
      background="#ffffff"
      placeholder="请输入人名或身份证号或手机号"
      @search="search"
    >
      <template #action>
        <div :style="actionStyle" @click="search">搜索</div>
      </template>
    </van-search>
    <div class="pl2 pr2" >
      <div v-if="!loading && total > 0" class="pt5 pb5 search-result">
        共搜索到<span class="font-bold fc-error">{{ total }} </span>个<template v-if="params.keywords">「{{params.keywords}}」相关</template>“不诚信”人员
      </div>
      <!-- <div class="">根据条件一共找到{{totalCount||0}}条黑名单信息</div> -->
      <van-list
        v-model="loading"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        :finished="finished"
        :finished-text="records.length > 10 ? '没有更多了' :''"
        @load="loadMore"
      >
        <div v-for="(record) in records" :key="record.id">
          <div class="connection-box pt7 pb7 pl5 pr5 fs6" @click="goDetail(record)">
            <div class="row align-items-start">
              <div class="flex-1">
                <div class="row align-items-center">
                  <div class="blacklist-name ellipsis-1 pr5">{{ record.name || '' }}</div>
                  <div v-if="!record.gender" class="pr5">{{ record.gender || '' }}</div>
                  <div v-if="record.address" class="pr5">{{ record.address || '' }}</div>
                </div>
                <div class="row align-items-center pt2" v-for="fd in fields" :key="fd.field">
                  <div class="pr5 fc-less field-label">{{ fd.label }}</div>
                  <div class="flex-1 field-value">{{ record[fd.field] || '' }}</div>
                </div>
              </div>
              <div v-if="record.name" class="row align-items-center justify-content-center blacklist-avatar">{{ record.name.substring(0, 1) }}</div>
            </div>
            <div v-if="record.remark" class="pt5">{{ record.remark || '' }}</div>
            <!-- <div v-if="record.informantName" class="pt5">信息由{{record.informantName||''}}{{record.phoneNumber||''}}提供，如您也被骗，可联系{{record.informantName || ''}}一起向当地派出所立案</div> -->
          </div>
        </div>
      </van-list>
      <div class="fs3 fc-info-dis padding5 text-center">
        <template v-if="!loading">
          <template v-if="total < 1">
            <div style="padding-top: 20vh;">{{ emptyTip }}</div>
            <div v-if="totalCount > 0" class="fc-default pt5">目前已收录<sapn class="fc-primary">{{totalCount}}</sapn>条黑名单信息</div>
            <!-- <div class="fc-default pt2 pb7">如果你有“不诚信”人员相关信息提供，请点击下方按钮</div>
            <van-button @click="report" type="danger">点我举报</van-button> -->
          </template>
        </template>
      </div>
      <div class="fixed-bottom row justify-content-center">
        <van-button @click="back()" class="btn-common" type="info" plain size="large">返回</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { sendRequest, getBlackList } from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'blacklistResult',
  components: { },
  data() {
    return {
      actionStyle: {
        // color: '#ffffff',
        width: '60px',
        height: '36px',
        'line-height': '36px',
        'background-color': 'yellow',
        'font-weight': 'bold',
        'border-radius': '20px',
        'text-align': 'center',
      },
      loading: false,
      isAdmin: storage.local.get('type') === 1, // 1 管理员 2 报价商 3 测试 4 生产的测试用户
      error: false,
      finished: false,
      size: 20,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],
      params: {},
      fields: [
        {
          label: '微信号码',
          field: 'wxNumber',
        },
        {
          label: '手机号码',
          field: 'phoneNumber',
        },
        {
          label: '身份证号',
          field: 'idNumber',
        },
      ],
      totalCount: 0,
    };
  },
  computed: {
    // showParams() {
    //   return
    // },
    emptyTip() {
      const { keywords } = this.params;
      return `抱歉，没有搜索到${keywords ? `「${keywords}」` : ''}有关信息`;
    },
  },
  methods: {
    report() {
      storage.session.set('BLACK_ITEM', {});
      this.$router.push('/black/list/edit');
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getBlackList(this.current + 1);
    },
    search() {
      this.getBlackList(1);
    },
    getPriData(data = '') {
      if (this.isAdmin) {
        return data;
      }
      if (!data) {
        return '';
      }
      if (data.length < 4) {
        return `${data.substring(0, 2)}****`;
      }
      const start = data.substring(0, 3);
      const end = data.substring(data.length - 4, data.length);
      return `${start}****${end}`;
    },
    getBlackList(page = 1) {
      // console.log(this.loading);
      this.loading = true;
      sendRequest(getBlackList, Object.assign({}, this.params, {
        current: page,
        size: this.size,
      })).then((res) => {
        // console.log(res);
        const {
          total = 0, records: datas = [], pages = 1,
        } = res;
        const records = datas.map((item) => {
          const {
            wxNumber = '', phoneNumber = '', idNumber = '', ...other
          } = item;
          return {
            ...other,
            wxNumber: this.getPriData(wxNumber),
            phoneNumber: this.getPriData(phoneNumber),
            idNumber: this.getPriData(idNumber),
          };
        });
        if (page === 1) {
          this.records = records || [];
        } else {
          this.records = this.records.concat(records || []);
        }
        this.total = this.records.length > 0 ? total : 0;
        this.totalCount = total;
        this.pages = pages;
        this.current = page;
        if ((records || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.error = false;
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
        this.total = 0;
        this.totalCount = 0;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    back() {
      this.$router.push('/black/list/query');
    },
  },
  created() {
    // this.getBlackList();
    this.params = storage.session.get('BLACK_PARAMS') || {};
    if (Object.keys(this.params).length < 1) {
      this.back();
    }
  },
});
</script>
<style scoped>
.blacklistResult {
    min-height: 100vh;
    padding: 0;
    padding-bottom: 90px;
  }
  .required-box {
    width: 90px;
  }
  .blacklistResult .records-item {
    background-color: #ffffff;
    /* margin-top: 10px; */
    padding: 2px 0 15px 0;
    border-top: 1px solid #b7afaf;
    margin-top: 12px;
    border-radius: 6px;
  }
  .line {
    border-top: 1px solid #b7afaf;
  }
  .record-label {
    width: 80px;
    padding-left: 10px;
  }
  .record-list {
    border-radius: 6px;
    padding: 2px 4px;
    border: 1px solid #1989fa;
  }
  .fixed-bottom {
    position: fixed;
    bottom: 20px;
    left: 0;
    width: 100%;
    padding: 0 30px;
  }

  .blacklistResult >>> .van-search .van-field__control {
    border: none!important;
  }
  .blacklistResult >>> .van-search__action {
    background: transparent!important;
  }

  .blacklistResult .connection-box {
    margin-top: 10px;
    background-color: #ffffff;
    border-left: 4px solid #c00;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .connection-box .blacklist-name {
    max-width: calc(100% - 55px - 60px);
    font-weight: bold;
  }
  .connection-box .field-label {
  }
  .connection-box .connection-region {
    width: 80px;
  }
  .blacklist-avatar {
    background-color: #c0c4cc;
    width: 60px;
    height: 60px;
    border-radius: 4px;
  }
</style>
